
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
import { Header } from "element-ui";
@Component({
  name: "brandSecondType",
})

export default class brandSecondType extends Vue {
	
  data(){
	  return{
		dialogVisible: false,
		dialogTitle:'',
		productAttrCate:{
		  name:'',
		  id:null
		},  
		rules: {
		  name: [
		    { required: true, message: '请输入类型名称', trigger: 'blur' }
		  ]
		},
		settleType:1
	  }
  };
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
	let paramter = {
		pageNum:1,
		pageSize:1000000,
		parentId:this.$route.query.cid,
	};
	this.$http.get("goodsType/list", {params:paramter}).then((res: any) =>{
		
		this.tableData = res.data.data.data;
		this.tableData = this.tableData.map(item=>{

			if(item.enable == 1) {

				item.enable = true;
			} else {

				item.enable = false;
			}
			return item;
		});
		
	});
  }
  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit() {
	  
	this.settleType = 1;
	this.dialogVisible = true;
	this.dialogTitle = "编辑类型";
	
  }
  private handleClose() {
	
	this.dialogVisible = false;
  }
  private handleUpdate(index:any, row:any){
	  
	  this.settleType = 2;
	  this.dialogVisible = true;
	  this.dialogTitle = "编辑类型";
	  this.productAttrCate.name = row.name;
	  this.productAttrCate.id = row.id;
  }
  private sureSubmit(value:any){
	  
	  let settleType = value;
	  if(settleType == 1) {
		  
		  // 新增类型
		  let paramter = {
		  	level:2,
		  	name:this.productAttrCate.name,
		  	parentId:this.$route.query.cid,
		  };
		  this.$http.post("goodsType/add/", paramter).then((res: any) =>{
		  	
		  		this.$confirm('添加成功');
		  		this.dialogVisible = false;
		  	// this.tableData = res.data;
		  });
		  
	  } else {
		  
		  // 编辑类型
		  let paramter = {
		  	level:2,
		  	name:this.productAttrCate.name,
		  	parentId:this.$route.query.cid,
		  };
		  this.$http.put("goodsType/edit/"+this.productAttrCate.id, paramter).then((res: any) =>{
		  	
				this.dialogVisible = false;
		  		this.$confirm('修改成功');
		  	// this.tableData = res.data.data;
		  });
	  }
  }
  private userStateChange(item:any){
  	  
	  console.log('我是item',item);
  	  // 是否开启类型
	  // 编辑类型
	  var itemTemp = item;
	  if(item.enable == true) {
		  
		  let paramter = {
		  	id:itemTemp.id,
		  };
		  this.$http.delete("goodsType/on/"+itemTemp.id, {body:paramter}).then((res: any) =>{
		  	
				let data = res.data;
				if(data.code == 200) {
					
					this.$confirm(data.msg);
				}
		  });
		   
	  } else {
		  
		  let paramter = {
		  	id:itemTemp.id,
		  };
		  this.$http.delete("goodsType/off/"+itemTemp.id, {body:paramter}).then((res: any) =>{
		  	
				let data = res.data;
				console.log('[[[[]]]]',data.msg);
				if(data.code == 200) {
					
					this.$confirm(data.msg);
				}
		  		
		  });
	  }
  }
}
